import { IBookStatus } from 'entities/Reservations';

const bookStatusState = {
  1: {
    status: 1,
    text: 'не підтверджена',
    color: 'blue',
    shortName: 'unconfirmed',
  },
  2: {
    status: 2,
    text: 'підтверджена',
    color: 'yellow',
    shortName: 'confirmed',
  },
  3: {
    status: 3,
    text: 'видалена',
    color: '',
    shortName: 'deleted',
  },
  4: {
    status: 4,
    text: 'відхилена',
    color: 'red',
    shortName: 'declined',
  },
  5: {
    status: 5,
    text: 'іншого менеджера',
    color: 'gray',
    shortName: 'otherManager',
  },
  6: {
    status: 6,
    text: 'завершено',
    color: 'green',
    shortName: 'done',
  },
};

export const useBookStatus = (status: IBookStatus) => bookStatusState[status];
